import { render } from "./SmsChargeWarning.vue?vue&type=template&id=13d9ad61"
import script from "./SmsChargeWarning.vue?vue&type=script&lang=js"
export * from "./SmsChargeWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItemLabel});
